import { CancelSmartphoneMododalFormSchema } from './CancelSmartphoneModal.types'

export const cancelSmartphoneModalDefaultValues: CancelSmartphoneMododalFormSchema =
  {
    message: '',
  }
